// extracted by mini-css-extract-plugin
export default {"container":"styles_container__IIeKM","container__title":"styles_container__title__lOlP0","pagination":"styles_pagination__XRII+"};